import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';

import { props as viewerPropsMapper } from './TextParticles.mapper';

const props = composeMapper<PreviewWrapperProps<any>, any, any>()(
  viewerPropsMapper,
  {
    add: ['componentViewMode'],
  },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    const { componentViewMode } = deps;
    return {
      ...viewerProps,
      componentViewMode,
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
